export const MODAL_TYPES = {
  CONFIRM: 'confirm',
  CLOSE: 'close',
} as const;

interface BaseModalProps {
  titleAlign?: 'center' | 'left';
  content: React.ReactNode;
  children?: React.ReactNode;
  onCloseModal?: () => void;
  onShow?: () => void;
  externalShow?: boolean;
  disableOutsideClick?: boolean;
  subTitle?: string;
  footer?: {
    left?: React.ReactNode;
    right?: React.ReactNode;
    guide?: React.ReactNode;
  };
}

/**
 * 외부에서 모달을 열 경우 사용하는 props입니다.
 */
export type ExternalModalProps = {
  disableOutsideClick?: boolean;
  externalShow?: boolean;
  onCloseModal?: () => void;
};

interface ConfirmModalProps extends BaseModalProps {
  type: typeof MODAL_TYPES.CONFIRM;
  title: string;
  footer: {
    left?: React.ReactNode;
    right?: React.ReactNode;
    guide?: React.ReactNode;
  };
}

interface CloseModalProps extends BaseModalProps {
  type: typeof MODAL_TYPES.CLOSE;
  title: string | React.ReactNode;
}

export type ModalProps = ConfirmModalProps | CloseModalProps;

export interface ModalTriggerProps {
  children: React.ReactNode;
  onClickShowModal: () => void;
}

export interface ModalTitleProps {
  onCloseModal?: () => void;
}
